/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_VakantieregioInputs */

const nl_planning_vakanties_vakantieregio = /** @type {(inputs: Planning_Vakanties_VakantieregioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakantieregio`)
};

/**

* @param {Planning_Vakanties_VakantieregioInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_vakantieregio = /** @type {((inputs?: Planning_Vakanties_VakantieregioInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_VakantieregioInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_vakantieregio(inputs)
});
export { planning_vakanties_vakantieregio as "planning.vakanties.vakantieregio" }